<template>
  <v-container>
    <v-card>
      <v-card-title>Mission Statement</v-card-title>
      <v-card-text>
        Our mission is to promote and defend responsible wildlife management and the North American Model of Wildlife Conservation. We strive to ensure responsible sportsmanship by advocating for ethical conservation policies. We also aim to inspire hunting enthusiasts with any background to experience hunting mountain lions through education and collaboration. Furthermore, we are committed to helping youth hunters develop their skills and knowledge in a safe and ethical manner.
      </v-card-text>
    </v-card>
    <BoardOfDirectors />
  </v-container>
</template>

<script>
import BoardOfDirectors from '../components/BoardOfDirectors.vue'; // Adjust the path as necessary

export default {
  name: 'AboutPage',
  components: {
    BoardOfDirectors,
  },
};
</script>

<style scoped>
/* Add any additional styles here */
</style>
